import PrivacyPolicyFaqAccordion from "../components/layout/privacyPolicyFaq/PrivacyPolicyFaqAccordion";
import styled from "@emotion/styled";
import t from "../helper/t";
import { HeaderImageDiv, HeaderText } from "../components/elements/HeaderImageDiv";
import HeadWithTags from "../components/elements/HeadWithTags";

import image from "../../public/img/privacy-policy-faq.webp";

const ImageDiv = styled(HeaderImageDiv)([
    {
        display: "flex",
        flexDirection: "column",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        height: 200,
    }
]);

interface PrivacyPolicyProps { }

const PrivacyPolicyFaqComponent: React.FC<PrivacyPolicyProps> = () => {
    return (
        <>
            <HeadWithTags name="privacy_policy_faq" />
            <div>
                <ImageDiv image={image}>
                    <HeaderText>
                        {t("Datenschutzhinweise")}
                        <br />
                        {t("Vodafone Speedtest Plus")}
                    </HeaderText>
                </ImageDiv>

                <div style={{ paddingTop: 34 }}>
                    <PrivacyPolicyFaqAccordion />
                </div>

                <div style={{
                    display: "flex",
                    marginTop: 32,
                    flexDirection: "column",
                    alignItems: "center",
                }}>
                    <div onClick={() => {
                        window.close();
                    }} className="button-rectangle-left rectangle-grey">
                        <div data-cy="button-tips" className="button-rectangle-text white-label">
                            {t("Zurück zum Speedtest Plus")}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PrivacyPolicyFaqComponent;
